import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const user = localStorage.getItem('currentAdmin');
    if (request.url.endsWith('/login')) {
      return next.handle(request);
    }
    try {
      const options: any = {};
      const currentUser = JSON.parse(user);
      if (currentUser && currentUser.token) {
        options.setHeaders = {
          Authorization: `Bearer ${currentUser.token}`
        };
        request = request.clone(options);
      }
    } catch {}

    return next.handle(request);
  }
}
